import React from 'react';
import PageTemplate from '../components/PageTemplate';

const Blog = () => {
  return (
    <PageTemplate
      title="Blog & Insights"
      subtitle="Stay updated with the latest technology trends and insights"
      breadcrumb="Blog"
    >
      <div className="content-section">
        <h2>Coming Soon</h2>
        <p>Our blog section is under development. We'll be sharing valuable insights, industry trends, and technical articles soon.</p>
      </div>
    </PageTemplate>
  );
};

export default Blog; 